import { render, staticRenderFns } from "./LeftoverModalItem.vue?vue&type=template&id=4249bac9&"
import script from "./LeftoverModalItem.vue?vue&type=script&lang=js&"
export * from "./LeftoverModalItem.vue?vue&type=script&lang=js&"
import style0 from "./LeftoverModalItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports